module.exports = __webpack_public_path__ + "static/img/bg_head.d3dab19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_head.jpg
// module id = bnuO
// module chunks = 1